import { render } from "./D3Chart.vue?vue&type=template&id=98b9d600"
import script from "./D3Chart.vue?vue&type=script&lang=js"
export * from "./D3Chart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__